import parse from "html-react-parser"
import Section from "../Section"
import styles from "./TargetSolution.module.scss"
import { getColors } from "utils/color-combinations"
import cx from "classnames"

const oppositeColors = {
  berry: "berry",
  grey: "lightgrey",
  lightgrey: "grey",
  white: "black",
  black: "white",
}

const TargetSolution = ({ data }) => {
  const { target_text: targetText, solution_text: solutionText, locale } = data

  const colors = getColors({
    theme_colors_combinations: {
      value: oppositeColors[data.theme_colors_combinations?.value || "berry"],
    },
    background_color: {
      value: oppositeColors[data.background_color?.value || "black"],
    },
  })

  return (
    targetText &&
    solutionText && (
      <Section
        sectionSpacing={{
          top: data?.section_padding_top?.value || null,
          bottom: data?.section_padding_bottom?.value || null,
        }}
        className={cx(styles.targetSolution, {
          [styles[`targetSolution--${locale}`]]: locale,
        })}
        colors={colors}
      >
        <div className={styles.wrapper}>
          <div className={styles.target}>
            <h2>Die Herausforderung</h2>
            <div className={styles.text}>{targetText && parse(targetText)}</div>
          </div>
          <div className={styles.solution}>
            <h2>Unsere Lösung</h2>
            <div className={styles.text}>
              {solutionText && parse(solutionText)}
            </div>
          </div>
        </div>
      </Section>
    )
  )
}

export default TargetSolution
